import React, { FunctionComponent } from "react"
import sketchyColors from "../Utils/SketchyColors"
import SketchyColorTypes from "../Types/SketchyColorTypes"
import { OverlayTrigger } from "react-bootstrap"
import sketchyTooltip from "../Utils/SketchyTooltip"
import "./SketchyColorPicker.css"

interface Props {
    manageParentState: Function
    color: SketchyColorTypes
}

const SketchyColorPicker: FunctionComponent<Props> = (props) => {

    const { manageParentState, color } = props

    return (
        <div className="SketchyColorPicker">
            {sketchyColors.map((c, i) =>
                <OverlayTrigger placement="top" overlay={sketchyTooltip(`Use ${c.name}`)} key={i}>
                    <div className="SketchyColorPickerColorItemOuter"
                        key={i}
                        onClick={() => manageParentState([
                            { key: "color", value: c },
                            { key: "isErasing", value: false }
                        ])}
                        style={{ borderBottom: `${c.hc === color.hc ? "2px solid #007bff" : "unset"}` }}
                    >
                        <div
                            className="SketchyColorPickerColorItemInner"
                            style={{ backgroundColor: c.hc }}
                        >
                        </div>
                    </div>
                </OverlayTrigger>
            )}
        </div>
    )
}

export default SketchyColorPicker
